interface Props {
  children: React.ReactElement | React.ReactElement[];
}

export const Main = ({ children }: Props) => (
  <main className="flex-1 overflow-y-auto overflow-x-clip p-4">{children}</main>
);
